<app-topbar (toggleSidebar)="onToggleSidebar()" />

<div
  class="shell-container"
  [class.sidebar-collapsed]="isSidebarCollapsed() && !isMobile()"
>
  <app-sidebar 
    [collapsed]="isSidebarCollapsed()" 
    [mobileOpen]="isSidebarOpen()"
    [isMobile]="isMobile()"
  />

  @if (showBackdrop()) {
    <div class="shell-backdrop" (click)="onBackdropClick()" role="presentation"></div>
  }

  <main class="shell-content">
    <div class="shell-main-content">
      <router-outlet />
    </div>
  </main>
</div>
